<template>
  <b-row>
    <b-col>
      <b-form-group :label="label" :label-for="fieldName">
        <b-form-input
          :id="fieldName"
          :placeholder="placeHolder"
          :required="required"
          :value="value"
          @input="updateValue($event)"
          :type="type"
          v-bind="$attrs"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    fieldName: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    placeHolder: {
      type: String,
      default: "",
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    type: {
      type: String,
      required: false,
      default: "text"
    },
    value: {
      type: String,
      required: true,
      default: ""
    }
  },
  methods: {
    updateValue(val) {
      this.$emit("input", val);
    }
  }
};
</script>

<style lang="scss" scoped></style>
